import { render, staticRenderFns } from "./FreqInput.vue?vue&type=template&id=98eba24c&scoped=true&"
import script from "./FreqInput.vue?vue&type=script&lang=js&"
export * from "./FreqInput.vue?vue&type=script&lang=js&"
import style0 from "./FreqInput.vue?vue&type=style&index=0&id=98eba24c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98eba24c",
  null
  
)

export default component.exports